var NODE_MAP = {};

export default NODE_MAP;


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/svg/node-map.js
// module id = ../../../../@progress/kendo-drawing/dist/es/svg/node-map.js
// module chunks = vendor